import Vue from 'vue'
import Vuex from 'vuex'
import user from '../modules/user'
import app from '../modules/app'
import login from '../modules/login'
import account from './account.ts'
import complianceAccount from '../complianceAccount/index'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        user,
        login,
        account,
        complianceAccount,
    },
})

export default store
